import { Component } from '@angular/core';

@Component({
  selector: 'app-sblock-sliders',
  templateUrl: './sliders.component.html',
  styleUrls: ['./sliders.component.scss']
})
export class SblockSlidersComponent {

  title = 'Vive la experiencia Adoratrices';
  subtitle = 'Un recorrido por los momentos que nos definen';
  titlesColor = '#2c3e50';

  slider: Array<{
    title: string;
    description: string;
    image: string;
    url: string;
  }> = [
    {
      title: 'Bienvenida al nuevo curso',
      description: 'Comenzamos el año acompañando a cada familia en su camino.',
      image: 'https://picsum.photos/seed/sld1/1280/560',
      url: '#'
    },
    {
      title: 'Aprender haciendo',
      description: 'Proyectos que despiertan la curiosidad y el pensamiento crítico.',
      image: 'https://picsum.photos/seed/sld2/1280/560',
      url: '#'
    },
    {
      title: 'Comunidad que cuida',
      description: 'Un entorno seguro donde cada persona es valorada.',
      image: 'https://picsum.photos/seed/sld3/1280/560',
      url: '#'
    }
  ];

}
